module.exports = __webpack_public_path__ + "img/06.229765a3.png";